import React from "react";
import { cn } from "@sys42/utils";
import * as styles from "./styles.module.css";

import logoSpotify from "./Spotify.svg";
import logoVirgin from "./Virgin.svg";
import logoAmazon from "./amazon.svg";
import logoAudi from "./audi.svg";
import logoPorsche from "./porsche.svg";
import logoShopify from "./shopify.svg";

export function Brands(props) {
  const { className, hideDescription } = props;

  return (
    <div className={cn(className, styles.brands)}>
      <div className={styles.logos}>
        <img src={logoAmazon} alt={"Logo: Amazon"} />
        <img src={logoVirgin} alt={"Logo: Virgin"} />
        <img src={logoSpotify} alt={"Logo: Spotify"} />
        <img src={logoPorsche} alt={"Logo: Porsche"} />
        <img src={logoAudi} alt={"Logo: Audi"} />
        <img src={logoShopify} alt={"Logo: Shopify"} />
      </div>
      {!hideDescription && (
        <div className={styles.description}>
          UX teams from these companies are already testing with Userbrain.
        </div>
      )}
    </div>
  );
}
